import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAllUsers, IGenericResponse, IRoles, IUser, UserRequest } from './../models/vk-users.model';

@Injectable({
  providedIn: 'root'
})
export class VkUsersService {
  apiBaseUrl: string;
  accessToken: string;
  
  private authHeaders: HttpHeaders;

  constructor(private http: HttpClient) {}

  getAllUsers(): Observable<IGenericResponse> {
    this._setAuthHeaders(this.accessToken);
    return this.http.get<IAllUsers>(`${this.apiBaseUrl}get-all`, { headers: this.authHeaders });
  }

  getRolesForUser(userId: string): Observable<IGenericResponse> {
    this._setAuthHeaders(this.accessToken);
    return this.http.get<IRoles>(`${this.apiBaseUrl}get-roles/`+userId, { headers: this.authHeaders });
  }

  newUser(user: IUser, concatenatedRoleNames: string): Observable<IGenericResponse> {
    const url = this.apiBaseUrl + 'new';
    let body = new UserRequest(user.UserId, user.UserName, user.Email, user.Password, concatenatedRoleNames, (user.Comment === null ? " " : user.Comment));
    return this.http.post<IGenericResponse>(url, body, { headers: this.authHeaders });
  }

  editUser(user: IUser, concatenatedRoleNames: string): Observable<IGenericResponse> {
    const url = this.apiBaseUrl + 'edit';
    let body = new UserRequest(user.UserId, user.UserName, user.Email, user.Password, concatenatedRoleNames, user.Comment);
    return this.http.put<IGenericResponse>(url, body, { headers: this.authHeaders });
  }

  private _setAuthHeaders(access_token: string) {
    const userToken = 'Bearer ' + access_token;
    this.authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': userToken });
  }
}
